import React from 'react'
import classes from './Form.scss'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'
import Checkbox from '@material-ui/core/Checkbox'
// import FormLabel from '@material-ui/core/FormLabel'
// import FormControl from '@material-ui/core/FormControl'
// import FormGroup from '@material-ui/core/FormGroup'
// import FormControlLabel from '@material-ui/core/FormControlLabel'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
// import FormHelperText from '@material-ui/core/FormHelperText'
const form = ({ form, inputChanged, scoreChanged }) => {
  let tabContent = null

  tabContent = Object.entries(form).map(res => {
    let [key, attr] = res

    if (key === 'is_threshold' && attr.disabled) {
      return null
    } else if (key === 'is_unlimited' && attr.disabled) {
      return null
    } else if (key === 'is_get_zero' && attr.disabled) {
      return null
    } else if (key === 'is_competencyScore' && attr.disabled) {
      return null
    } else if (key === 'is_self_delete_comment' && attr.disabled) {
      return null
    } else if (key === 'comment_score') {
      if (
        form.is_competencyScore.value &&
        !form.is_competencyScore.disabled &&
        form.target_score.value !== null &&
        form.target_score?.elementConfig?.options
      ) {
        console.log('attr', attr)
        let check = attr.value?.split(',') || []
        let option = form.target_score.elementConfig.options.filter(
          item => +item.value <= +form.target_score.value.value
        )

        return (
          <Grid container direction='row' justify='flex-start' alignItems='center'>
            <Grid item xs={12}>
              <Typography variant='colorTextPrimary'>{attr.label}</Typography>
            </Grid>
            {option.length > 0
              ? option.map(item => (
                  <Grid item xs={6} sm={2}>
                    <Checkbox
                      checked={check.find(c => +c === item.key)}
                      onChange={() => scoreChanged(item.key)}
                    />
                    <Typography variant='colorTextPrimary'>{item.key}</Typography>
                  </Grid>
                ))
              : null}
            {/* <FormControl component='fieldset' className={classes.formControl}>
              <FormLabel component='legend'>aaa{attr.label}</FormLabel>
              <FormGroup>
                {attr.elementConfig.options.length > 0
                  ? attr.elementConfig.options.map(item => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={item.value}
                            onChange={() => scoreChanged(item.key, !item.value)}
                          />
                        }
                        label={item.key}
                      />
                    ))
                  : null}
              </FormGroup>
            </FormControl> */}
          </Grid>
        )
      } else {
        return null
      }
    } else {
      return (
        <InputGroup
          key={key}
          label={attr.label}
          inputType={attr.elementType}
          configs={attr.elementConfig}
          invalid={!attr.valid}
          validations={attr.validation}
          touched={attr.touched}
          changed={e => inputChanged(key, e)}
          inputValue={attr.value}
          validationError={attr.error}
        />
      )
    }
  })

  return <div className={classes.Form}>{tabContent}</div>
}

export default form
